'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports['default'] = undefined;

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _defaults(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : _defaults(subClass, superClass); }

/** Table.GroupHeader */
var GroupHeader = (_temp = _class = function (_React$Component) {
    _inherits(GroupHeader, _React$Component);

    function GroupHeader() {
        _classCallCheck(this, GroupHeader);

        return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
    }

    GroupHeader.prototype.render = function render() {
        return null;
    };

    return GroupHeader;
}(_react2['default'].Component), _class.propTypes = {
    /**
     * 行渲染的逻辑
     */
    cell: _propTypes2['default'].oneOfType([_propTypes2['default'].element, _propTypes2['default'].node, _propTypes2['default'].func]),
    /**
     * 是否在GroupHeader上面渲染selection
     */
    hasSelection: _propTypes2['default'].bool
}, _class._tableMark = 'list-group-header', _class.defaultProps = {
    cell: function cell() {
        return '';
    },
    hasSelection: false
}, _temp);
GroupHeader.displayName = 'GroupHeader';
exports['default'] = GroupHeader;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@alicd_next@0.19.78@@alicd/next/lib/_components/@alicd/next-table/lib/group-header.js
// module id = 475
// module chunks = 0